import { render, staticRenderFns } from "./joker.vue?vue&type=template&id=123f0772&scoped=true"
import script from "./joker.vue?vue&type=script&lang=js"
export * from "./joker.vue?vue&type=script&lang=js"
import style0 from "./joker.vue?vue&type=style&index=0&id=123f0772&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "123f0772",
  null
  
)

export default component.exports